import {
  AccountingImportDoctolibCsvApiResponseError,
  GetAccountingApiEntity,
  HttpErrors,
} from '@omecare/utils';
import { ImportAccountingDoctorAttendingCsvFormValues } from '@/components/forms/import-accounting-doctor-attending-csv-form/schema';
import { useImportAccountingDoctorAttendingCsvForm } from '@/components/forms/import-accounting-doctor-attending-csv-form/use-import-accounting-doctor-attending-csv-form';
import useAccountingImportDoctolibCsvMutation from '@/hooks/mutations/use-accounting-import-doctolib-csv';
import { popModal, pushModal } from '..';

export type ImportAccountingDoctorAttendingCsvModalApi = {
  onSuccess: ({ data }: { data: GetAccountingApiEntity[] }) => void;
  onClose?: () => void;
  onCancel?: () => void;
};
export const useImportAccountingDoctorAttendingCsvModalViewModel = ({
  api,
}: {
  api: ImportAccountingDoctorAttendingCsvModalApi;
}) => {
  const { importAccountingDoctorAttendingCsvForm: importForm } =
    useImportAccountingDoctorAttendingCsvForm();

  const closeModel = () => {
    popModal('ImportAccountingDoctorAttendingCsvModal');
    api.onClose?.();
  };

  const cancelModel = () => {
    popModal('ImportAccountingDoctorAttendingCsvModal');
    api.onCancel?.();
  };

  const importDoctolibCsvMutation = useAccountingImportDoctolibCsvMutation();

  const submitImport = (
    values: ImportAccountingDoctorAttendingCsvFormValues,
  ) => {
    importDoctolibCsvMutation.mutate(
      {
        officeId: values.officeId,
        doctorAttendingId: values.doctorAttending.id,
        doctolibFile: values.doctolibAccountingFile,
      },
      {
        onSuccess: (accountingList) => {
          popModal('ImportAccountingDoctorAttendingCsvModal');
          api.onSuccess({
            data: accountingList.data,
          });
        },
        onError: (error: HttpErrors) => {
          pushModal('ImportAccountingDoctorAttendingCsvReportModal', {
            report: {
              error: error.data as AccountingImportDoctolibCsvApiResponseError,
            },
            officeId: values.officeId,
            doctorAttending: {
              id: values.doctorAttending.id,
              firstname: values.doctorAttending.firstname,
              lastname: values.doctorAttending.lastname,
            },
          });
        },
      },
    );
  };

  return {
    api: {
      submit: () => {
        importForm.trigger();
        importForm.handleSubmit(submitImport)();
      },
      close: closeModel,
      cancel: cancelModel,
    },
    form: importForm,
    data: {
      saving: importDoctolibCsvMutation.isPending,
    },
  };
};

export type ImportAccountingDoctorAttendingCsvModalViewModel = ReturnType<
  typeof useImportAccountingDoctorAttendingCsvModalViewModel
>;
